import { runScripts } from '@/utils/RunScripts';

function setHtml(el, html) {
    el.innerHTML = html || '';
    runScripts(el);
}

export default {
    inserted(el, binding) {
        setHtml(el, binding.value);
    },

    update(el, binding) {
        if (binding.value !== binding.oldValue) setHtml(el, binding.value);
    },
};
